// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file booking_gateway/v1/updates.proto (package booking_gateway.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { SeatIDs } from "../../booking/types/v1/order_pb.js";

/**
 * EventOverview is the initial message when a client subscribes to updates for all section
 * of an event. This message describes the current state of each section (i.e. the number of
 * available seats). After this, event updates are sent so that the client should always be
 * up to date.
 *
 * @generated from message booking_gateway.v1.EventOverview
 */
export const EventOverview = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.EventOverview",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "availability", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ],
);

/**
 * EventUpdate is sent to update the available number of seats for each section.
 * These updates are sent periodically after the initial event overview message. Each update
 * holds data for all sections where something changed since the last update (or
 * the initial overview message if no update was sent yet), i.e. the availability map
 * always holds the current seat counts.
 *
 * If no changes happened, no update will be sent.
 *
 * @generated from message booking_gateway.v1.EventUpdate
 */
export const EventUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.EventUpdate",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "availability", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ],
);

/**
 * SectionOverview is the initial message when a client subscribes to updates of a
 * section. This message describes the current state of a section. After this, section
 * updates are sent so that the client should always be up to date.
 *
 * @generated from message booking_gateway.v1.SectionOverview
 */
export const SectionOverview = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.SectionOverview",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "available_seats" },
    { no: 4, name: "ids", kind: "message", T: SeatIDs, oneof: "available_seats" },
  ],
);

/**
 * SectionUpdate is sent when seats in a single section were reserved or available again.
 * These updates are sent continously after the initial section overview message. Each update
 * describes the change relative to the last update (or the initial overview message if no
 * update was sent yet). If no changes happened, no update will be sent.
 *
 * @generated from message booking_gateway.v1.SectionUpdate
 */
export const SectionUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.SectionUpdate",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "available_diff", kind: "scalar", T: 5 /* ScalarType.INT32 */, oneof: "seat_update" },
    { no: 4, name: "ids", kind: "message", T: SectionUpdate_SeatIDUpdate, oneof: "seat_update" },
  ],
);

/**
 * @generated from message booking_gateway.v1.SectionUpdate.SeatIDUpdate
 */
export const SectionUpdate_SeatIDUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.SectionUpdate.SeatIDUpdate",
  () => [
    { no: 1, name: "available", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 2, name: "reserved", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ],
  {localName: "SectionUpdate_SeatIDUpdate"},
);

/**
 * @generated from message booking_gateway.v1.SeatmapOverview
 */
export const SeatmapOverview = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.SeatmapOverview",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ga_availability", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 3, name: "seat_availability", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SeatIDs} },
  ],
);

/**
 * @generated from message booking_gateway.v1.SeatmapUpdate
 */
export const SeatmapUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.SeatmapUpdate",
  () => [
    { no: 1, name: "event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ga_availability", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 3, name: "seat_updates", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: SeatmapUpdate_SeatIDUpdate} },
  ],
);

/**
 * @generated from message booking_gateway.v1.SeatmapUpdate.SeatIDUpdate
 */
export const SeatmapUpdate_SeatIDUpdate = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.SeatmapUpdate.SeatIDUpdate",
  () => [
    { no: 1, name: "available", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 2, name: "reserved", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
  ],
  {localName: "SeatmapUpdate_SeatIDUpdate"},
);

/**
 * @generated from message booking_gateway.v1.HealthTest
 */
export const HealthTest = /*@__PURE__*/ proto3.makeMessageType(
  "booking_gateway.v1.HealthTest",
  () => [
    { no: 1, name: "healthy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

